import { type AppConfig } from "@indietabletop/appkit";
import "@indietabletop/appkit/globals.css.ts";
import icon from "../assets/icon.png";
import { client } from "../client.ts";
import { database, DatabaseProvider } from "../database/database.ts";
import { ExceptionPage } from "../ExceptionPage/ExceptionPage.tsx";
import { AppkitApp } from "../oss/AppkitApp.tsx";
import { fmt } from "./fmt.ts";
import { hrefs } from "./hrefs.tsx";
import { Routes } from "./Routes.tsx";

const config: AppConfig = {
  app: { name: "Greathelm", icon },
  isDev: import.meta.env.DEV,
  placeholders: { email: "E.g. lionheart@example.com" },
  client,
  database,
  hrefs,
  fmt,
};

const neverRestorePaths = ["/", "/rules", "/join", "/login", "/settings"];

export function App() {
  return (
    <AppkitApp
      config={config}
      neverRestoreScrollFor={neverRestorePaths}
      exceptionFallback={<ExceptionPage />}
      swPath="/sw.js"
    >
      <DatabaseProvider>
        <Routes />
      </DatabaseProvider>
    </AppkitApp>
  );
}
